module.exports = __webpack_public_path__ + "img/fr.f8952213.svg";